// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Strawford_6c2e9c', '__Strawford_Fallback_6c2e9c'"},"className":"__className_6c2e9c"};